import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetReactivatedDto extends IGetNotification {
    notificationType: NotificationType.assetReactivated
    assetId: Guid  // ID of the NEW reactivated asset (current version) - use this for navigation
    originalAssetId: Guid  // ID of the original disposed asset (previous version)
    lmid: string
    articleDescription?: string | null
}

export default class NotificationAssetReactivated extends Notification {
    asset: NotificationAsset
    originalAssetId: Guid

    constructor(dto: IGetNotificationAssetReactivatedDto) {
        super(dto)
        this.asset = new NotificationAsset({
            assetId: dto.assetId,  // NEW reactivated asset for navigation
            lmid: dto.lmid,
            articleDescription: dto.articleDescription ?? undefined
        })
        this.originalAssetId = dto.originalAssetId
    }
}
